// extracted by mini-css-extract-plugin
export var badge = "_h9-2";
export var detailsPanel = "_h9-0";
export var resultRow = "_h9-1";